import classNames from 'classnames';
import React, { memo, useEffect, useState } from 'react';
import axios from 'axios';

const FreeGiftCta = () => {
  return null;
  /*
  const [promos, setPromos] = useState(null);
  useEffect(() => {
    setTimeout(async () => {
      const { data } = await axios.get(jsRoutes.controllers.Cart.promos().url);
      setPromos(data);
    }, 0);
  }, []);

  return <>{promos?.length > 0 && promos.map((p, i) => <Promo key={i} {...p} />)}</>;
   */
};

const Promo = ({ description, threshold }) => {
  return (
    <div className='t-w-full tw:my-3 tw:bg-[#DFEAF5] tw:py-3 tw:text-center'>
      <div className='tw:font-bold'>
        Spend {threshold} and get a FREE {description}*
      </div>
      <div>*Gift will be added in cart</div>
    </div>
  );
};

export default memo(FreeGiftCta);
